/**
 * Event.key values
 */
export enum Key {
	SHIFT = 'Shift',
	ALT = 'Alt',
	CONTROL = 'Control',
	META = 'Meta',

	ESCAPE = 'Escape',
	TAB = 'Tab',
	ENTER = 'Enter',
	SPACE = ' ',
	ARROW_UP = 'ArrowUp',
	ARROW_DOWN = 'ArrowDown',

	PLUS = '+',
	MINUS = '-',
	F1 = 'F1',
	F3 = 'F3',
	F6 = 'F6',
	F7 = 'F7',
	F8 = 'F8',
	F10 = 'F10',
	F11 = 'F11',

	a = 'a',
	c = 'c',
	d = 'd',
	e = 'e',
	r = 'r',

	A = 'A',
	E = 'E',
	F = 'F',
	K = 'K',
	L = 'L',
	R = 'R',
	S = 'S',
	// X not working in browser, reserved key?
	// X = 'X',

	DELETE = 'Delete',
	HOME = 'Home',
	END = 'End',
	PAGE_UP = 'PageUp',
	PAGE_DOWN = 'PageDown',
	BACKSPACE = 'Backspace',
}

export enum KeyEvent {
	KEY_DOWN = 'keydown',
	// KEY_UP = 'keyup',
}
